import { CommonModule, DOCUMENT } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, Inject, Renderer2 } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { Client } from '@df/core/service/client';
@Component({
    selector: 'app',
    styles: [
        `
            :host {
                height: inherit;
            }
        `
    ],
    template: `<router-outlet></router-outlet>`,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [RouterOutlet, CommonModule]
})
export class AppComponent {
    constructor(
        private client: Client,
        elementRef: ElementRef<HTMLElement>,
        @Inject(DOCUMENT) private document: Document,
        private changeDetectorRef: ChangeDetectorRef,
        private router: Router,
        private renderer2: Renderer2
    ) {
        client.isCms$.subscribe(isCms => {
            if (isCms) {
                this.setAsRoot(elementRef.nativeElement);
            } else {
                this.setAsRoot((this.document.scrollingElement || this.document.body) as HTMLElement);
            }
        });
    }
    ngOnInit() {
        this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                // this.applicationRef.tick();
                this.detectChanges();
            }
        });
    }

    private setAsRoot(element: HTMLElement) {
        const currentRoot = this.client.getRootElement();
        if (currentRoot !== element) {
            if (currentRoot) {
                this.renderer2.removeClass(currentRoot, 'appRoot');
            }
            // appRoot class is set in global.scss
            this.renderer2.addClass(element, 'appRoot');
            this.client.setRootElement(element);
        }
    }
    private detectChanges() {
        this.changeDetectorRef.detectChanges();
    }
}
